import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function StoreAvailability(_x, _x2, _x3) {
  return _StoreAvailability.apply(this, arguments);
}

function _StoreAvailability() {
  _StoreAvailability = _asyncToGenerator(function* (context, reference, zipcode) {
    const locale = context.state.i18n.currentLocale;
    const xhrUri = "/nav/nav-api/product/".concat(locale.market, "/").concat(locale.language, "/shops-by-address/").concat(reference, "/").concat(zipcode);

    try {
      const {
        data
      } = yield context.$axios.get(xhrUri, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      return data;
    } catch (e) {
      console.log(e);
      return null;
    }
  });
  return _StoreAvailability.apply(this, arguments);
}

export default StoreAvailability;